export default __webpack_public_path__ + "static/media/influencer.574d22dc.mp4";